import React from 'react';
import { X } from 'lucide-react';
import HeroSlideFormFields from './HeroSlideFormFields';

export const AddHeroSlideModal = ({ heroSlides }) => {
  const { showAddHeroSlideModal, closeAddModal, heroSlideForm, setHeroSlideForm, handleHeroSlideSubmit } = heroSlides;
  if (!showAddHeroSlideModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-2xl font-bold text-gray-800">Add Hero Slide</h3>
            <button onClick={closeAddModal} className="text-gray-400 hover:text-gray-600">
              <X className="h-6 w-6" />
            </button>
          </div>

          <form onSubmit={handleHeroSlideSubmit} className="space-y-6">
            <HeroSlideFormFields form={heroSlideForm} setForm={setHeroSlideForm} />
            <div className="flex justify-end space-x-4">
              <button type="button" onClick={closeAddModal} className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
                Cancel
              </button>
              <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                Create Hero Slide
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const EditHeroSlideModal = ({ heroSlides }) => {
  const { editingHeroSlide, closeEditModal, heroSlideForm, setHeroSlideForm, handleHeroSlideSubmit } = heroSlides;
  if (!editingHeroSlide) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-2xl font-bold text-gray-800">Edit Hero Slide</h3>
            <button onClick={closeEditModal} className="text-gray-400 hover:text-gray-600">
              <X className="h-6 w-6" />
            </button>
          </div>

          <form onSubmit={handleHeroSlideSubmit} className="space-y-6">
            <HeroSlideFormFields
              form={heroSlideForm}
              setForm={setHeroSlideForm}
              currentImage={editingHeroSlide.image}
              currentImageTitle={editingHeroSlide.title}
            />
            <div className="flex justify-end space-x-4">
              <button type="button" onClick={closeEditModal} className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
                Cancel
              </button>
              <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                Update Hero Slide
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
